module.exports = __webpack_public_path__ + "static/media/shelf_divider.524ce50c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/SuperUser/img/shelf_divider.png
// module id = 999
// module chunks = 0